import type { AnyFSA } from '@makemydeal/dr-browser-utils';

// actions
import * as complianceActionCreators from '../actions/complianceActionCreators';

// interfaces/types
import { type DashMiddleware, type DashStore, type DashNext, bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import { PII_CONSISTENCY_SUCCESS } from '../actionTypes/complianceActionTypes';
import { getIsEcommerceDeal } from '../selectors/dealXgDetailsSelectors';

let hasDispatchedComplianceData = false;

export const middleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    next(action);
    const state = store.getState();
    const isEcommerceDeal = getIsEcommerceDeal(state);
    switch (action.type) {
        case bootstrapActionTypes.BOOTSTRAP_SUCCESS:
        case PII_CONSISTENCY_SUCCESS: {
            if (!hasDispatchedComplianceData && isEcommerceDeal) {
                hasDispatchedComplianceData = true;
                store.dispatch(complianceActionCreators.fetchPIIConsistencyData(state));
            }
            break;
        }
    }
};
